// Which touch controls show right now. While a modal holds the scene's input lock the joystick,
// the action button and the chat chip step aside — they sit above the canvas (z 1500/1600) and
// would otherwise take taps meant for the modal (the Rynek's Zamknij sat under the chat chip) or
// move Natalka behind it. The cancel button stays: it is how a placement is backed out of.
export function shellVisibility({ stickWanted, locked, hasAction, hasCancel }) {
  return {
    stick: Boolean(stickWanted) && !locked,
    action: Boolean(hasAction) && !locked,
    cancel: Boolean(hasCancel),
    chat: !locked,
  };
}
